/**
 * Set the guest refresh token cookie for unauthenticated users
 * This creates a long-lived token (1 week) for guest session tracking
 */
export const setGuestRefreshToken = async (guestInfo: { uid: string; referer?: string }) => {
    const response = await fetch("/query/setGuestRefreshToken", {
        method: "POST",
        body: JSON.stringify(guestInfo),
        headers: { "Content-Type": "application/json" },
        credentials: "include"
    });

    if (!response.ok) {
        throw new Error(response.statusText || "Failed to set guest refresh token");
    }

    // Response is empty (204 No Content or 200 OK with no body)
    return;
};

/**
 * Set the guest access token cookie for unauthenticated users
 * This creates a short-lived token (15 minutes) for API access
 * Requires a valid refresh token cookie to be present
 */
export const setGuestAccessToken = async () => {
    const response = await fetch("/query/setGuestAccessToken", {
        method: "POST",
        body: JSON.stringify({}),
        headers: { "Content-Type": "application/json" },
        credentials: "include"
    });

    if (!response.ok) {
        throw new Error(response.statusText || "Failed to set guest access token");
    }

    // Response is empty (204 No Content or 200 OK with no body)
    return;
};
